var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: _vm.editData.code || _vm.callType === "pass" ? "修改" : "新增",
        visible: _vm.dialogVisible,
        width: "1160px",
        top: "1%",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: { model: _vm.companyData, rules: _vm.rules },
            },
            [
              _c("el-row", { staticClass: "row" }, [
                _c("div", { staticClass: "panel" }, [
                  _c(
                    "div",
                    { staticClass: "form-item w-420" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("中文名称"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "nameCH" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入中文名" },
                            model: {
                              value: _vm.companyData.nameCH,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "nameCH", $$v)
                              },
                              expression: "companyData.nameCH",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-420" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("英文名称"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "nameEN" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入英文名" },
                            model: {
                              value: _vm.companyData.nameEN,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "nameEN", $$v)
                              },
                              expression: "companyData.nameEN",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-row", [
                _c("div", { staticClass: "panel" }, [
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("地址"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "address" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.addressDropOption,
                              placeholder: "请选择地址",
                              props: {
                                expandTrigger: "click",
                                value: "value",
                                label: "label",
                                children: "children",
                              },
                            },
                            model: {
                              value: _vm.companyData.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "address", $$v)
                              },
                              expression: "companyData.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-420" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("详细地址"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "addressDetail" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入详细地址" },
                            model: {
                              value: _vm.companyData.addressDetail,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "addressDetail", $$v)
                              },
                              expression: "companyData.addressDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("代码"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "code" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入代码(四-五位唯一)" },
                            model: {
                              value: _vm.companyData.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "code", $$v)
                              },
                              expression: "companyData.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("简称"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "wbName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入简称" },
                            model: {
                              value: _vm.companyData.wbName,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "wbName", $$v)
                              },
                              expression: "companyData.wbName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-row", [
                _c("div", { staticClass: "panel" }, [
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("状态"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "isActived" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.companyData.isActived,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyData, "isActived", $$v)
                                },
                                expression: "companyData.isActived",
                              },
                            },
                            _vm._l(_vm.activeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("销售员"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "saleId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择销售员" },
                              model: {
                                value: _vm.companyData.saleId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyData, "saleId", $$v)
                                },
                                expression: "companyData.saleId",
                              },
                            },
                            _vm._l(_vm.userOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("预警邮箱"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "noticeEmail" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入预警邮箱" },
                            model: {
                              value: _vm.companyData.noticeEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "noticeEmail", $$v)
                              },
                              expression: "companyData.noticeEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("结算币种"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "currency" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                disabled: !!_vm.editData.code,
                              },
                              model: {
                                value: _vm.companyData.currency,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyData, "currency", $$v)
                                },
                                expression: "companyData.currency",
                              },
                            },
                            _vm._l(_vm.currencyData, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("签订合同"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "bussinessFlag" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.companyData.bussinessFlag,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.companyData,
                                    "bussinessFlag",
                                    $$v
                                  )
                                },
                                expression: "companyData.bussinessFlag",
                              },
                            },
                            _vm._l(_vm.bussinessFlagOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-row", [
                _c("div", { staticClass: "panel" }, [
                  _c(
                    "div",
                    { staticClass: "form-item w-420" },
                    [
                      _c("label", { staticClass: "lable" }, [_vm._v("备注")]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入备注" },
                            model: {
                              value: _vm.companyData.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "remark", $$v)
                              },
                              expression: "companyData.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-200" },
                    [
                      _c("label", { staticClass: "lable" }, [_vm._v("法人")]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "legalMan" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入法人" },
                            model: {
                              value: _vm.companyData.legalMan,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "legalMan", $$v)
                              },
                              expression: "companyData.legalMan",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-item w-420" },
                    [
                      _c("label", { staticClass: "lable" }, [
                        _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                        _vm._v("合同期限"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "remark" } },
                        [
                          _c("BaseDateCommon", {
                            attrs: { width: "420" },
                            model: {
                              value: _vm.companyData.contractDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyData, "contractDate", $$v)
                              },
                              expression: "companyData.contractDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-row", [
                _c(
                  "div",
                  {
                    staticClass: "panel",
                    staticStyle: { "justify-content": "start" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-item w-200" },
                      [
                        _c("label", { staticClass: "lable" }, [
                          _vm._v("关键客户"),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "isCritical" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": _vm.companyData.isCritical
                                  ? "是"
                                  : "否",
                              },
                              model: {
                                value: _vm.companyData.isCritical,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyData, "isCritical", $$v)
                                },
                                expression: "companyData.isCritical",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "form-item w-420" },
                      [
                        _c("label", { staticClass: "lable" }, [
                          _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                          _vm._v("营业执照图片"),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "min-width": "240px" },
                            attrs: { prop: "certificateFileId" },
                          },
                          [
                            _vm.companyData.certificateFileId
                              ? _c("img", {
                                  staticClass: "license-preview",
                                  attrs: {
                                    src: _vm.companyData.certificateFileUrl,
                                  },
                                })
                              : _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-demo",
                                    attrs: {
                                      accept: ".png,.PNG,.JPG,jpg,jpeg,.JPEG",
                                      limit: 1,
                                      action: `/api/SystemFile/uploadFile?source=10`,
                                      data: { source: 10 },
                                      headers: _vm.headers,
                                      "file-list": _vm.fileList,
                                      "show-file-list": false,
                                      "on-success": _vm.onSuccess,
                                      "on-error": _vm.onError,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "license-upload" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "plus-icon" },
                                          [_vm._v("+")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tab" },
            [
              _c("div", { staticClass: "line" }),
              _c("BaseTab", {
                staticStyle: { "z-index": "1" },
                attrs: {
                  tabItems: _vm.tabItems,
                  propWidth: 490,
                  active: _vm.active,
                },
                on: { tabChange: _vm.tabChange },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active !== 2,
                  expression: "active !== 2",
                },
              ],
              staticClass: "add-item-content",
            },
            [
              _c("div", { staticClass: "add-item", on: { click: _vm.add } }, [
                _c("i", { staticClass: "el-icon-circle-plus-outline" }),
                _vm._v(" 添加 "),
              ]),
            ]
          ),
          _c("div", { staticClass: "baseTable" }, [
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === 0,
                    expression: "active === 0",
                  },
                ],
              },
              [
                _c("li", { staticClass: "header" }, [
                  _c("div", { staticClass: "cell" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("中文名"),
                  ]),
                  _c("div", { staticClass: "cell" }, [_vm._v("英文名")]),
                  _c("div", { staticClass: "cell" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("联系人类型"),
                  ]),
                  _c("div", { staticClass: "cell" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("手机"),
                  ]),
                  _c("div", { staticClass: "cell" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("邮箱"),
                  ]),
                  _c("div", { staticClass: "cell" }, [_vm._v("固定电话")]),
                  _c("div", { staticClass: "cell" }, [_vm._v("操作")]),
                ]),
              ]
            ),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === 0,
                    expression: "active === 0",
                  },
                ],
                staticClass: "tableBody",
              },
              [
                _vm._l(_vm.contactList, function (item, $index) {
                  return [
                    [
                      _c("li", { key: $index, staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "cell",
                            attrs: { title: item.nameCH },
                          },
                          [_vm._v(_vm._s(item.nameCH))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "cell",
                            attrs: { title: item.nameEN },
                          },
                          [_vm._v(_vm._s(item.nameEN))]
                        ),
                        _c("div", { staticClass: "cell" }, [
                          _vm._v(_vm._s(_vm._f("formatterType")(item.type))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "cell", attrs: { title: item.phone } },
                          [_vm._v(_vm._s(item.phone))]
                        ),
                        _c(
                          "div",
                          { staticClass: "cell", attrs: { title: item.email } },
                          [_vm._v(_vm._s(item.email))]
                        ),
                        _c(
                          "div",
                          { staticClass: "cell", attrs: { title: item.tel } },
                          [_vm._v(_vm._s(item.tel))]
                        ),
                        _c("div", { staticClass: "cell" }, [
                          _c("i", {
                            staticClass: "el-icon-edit",
                            attrs: { title: "修改" },
                            on: {
                              click: function ($event) {
                                return _vm.updateContactList($index)
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { "margin-left": "32px" },
                            attrs: { title: "删除" },
                            on: {
                              click: function ($event) {
                                return _vm.removeContactList($index)
                              },
                            },
                          }),
                        ]),
                      ]),
                    ],
                  ]
                }),
              ],
              2
            ),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === 1,
                    expression: "active === 1",
                  },
                ],
              },
              [
                _c("li", { staticClass: "header" }, [
                  _c("div", { staticClass: "cell1" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("跟进人类型"),
                  ]),
                  _c("div", { staticClass: "cell1" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("用户"),
                  ]),
                  _c("div", { staticClass: "cell1" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("中文名"),
                  ]),
                ]),
              ]
            ),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === 1,
                    expression: "active === 1",
                  },
                ],
                staticClass: "tableBody",
              },
              [
                _vm._l(_vm.followUpsList, function (item, $index) {
                  return [
                    [
                      _c("li", { key: $index, staticClass: "row" }, [
                        _c("div", { staticClass: "cell1" }, [
                          _vm._v(_vm._s(_vm._f("formatterType")(item.type))),
                        ]),
                        _c("div", { staticClass: "cell1" }, [
                          _vm._v(_vm._s(item.nameCH)),
                        ]),
                        _c("div", { staticClass: "cell1" }, [
                          _c("i", {
                            staticClass: "el-icon-delete",
                            attrs: { title: "删除" },
                            on: {
                              click: function ($event) {
                                return _vm.removeFollowUpsList($index)
                              },
                            },
                          }),
                        ]),
                      ]),
                    ],
                  ]
                }),
              ],
              2
            ),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === 2,
                    expression: "active === 2",
                  },
                ],
              },
              [
                _c("li", { staticClass: "header" }, [
                  _c("div", { staticClass: "cell2" }, [_vm._v("用户名")]),
                  _c("div", { staticClass: "cell2" }, [_vm._v("角色")]),
                  _c("div", { staticClass: "cell2" }, [_vm._v("电话")]),
                  _c("div", { staticClass: "cell2" }, [_vm._v("操作更新人")]),
                  _c("div", { staticClass: "cell2" }, [_vm._v("操作")]),
                ]),
              ]
            ),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === 2,
                    expression: "active === 2",
                  },
                ],
                staticClass: "tableBody",
              },
              [
                _vm._l(_vm.companyData.users, function (item, $index) {
                  return [
                    [
                      _c("li", { key: $index, staticClass: "row" }, [
                        _c("div", { staticClass: "cell2" }, [
                          _vm._v(_vm._s(item.userName)),
                        ]),
                        _c("div", { staticClass: "cell2" }, [
                          _vm._v(_vm._s(item.typeName)),
                        ]),
                        _c("div", { staticClass: "cell2" }, [
                          _vm._v(_vm._s(item.phoneNumber)),
                        ]),
                        _c("div", { staticClass: "cell2" }, [
                          _vm._v(_vm._s(item.updatedName)),
                        ]),
                        _c(
                          "div",
                          { staticClass: "cell2" },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": item.isActived ? "启用" : "停用",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.userSwitch(item)
                                },
                              },
                              model: {
                                value: item.isActived,
                                callback: function ($$v) {
                                  _vm.$set(item, "isActived", $$v)
                                },
                                expression: "item.isActived",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                  ]
                }),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("div", { staticClass: "cancel", on: { click: _vm.cancel } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ok",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
      _c("add-follow-ups-dialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
      _c("add-contact-dialog", {
        attrs: { dialogVisible: _vm.dialogVisible1, editRow: _vm.editRow },
        on: { ok: _vm.ok1, cancel: _vm.cancel1 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }